import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    BACK_LIQUIDACIONES_BASES_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.bases.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LIQUIDACIONES_BASES_LAST_DATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.bases.last.date'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LIQUIDACIONES_BASES_RESUMEN : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.bases.resumen'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LIQUIDACIONES_BASES_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.bases.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LIQUIDACIONES_BASES_SEND_REVIEW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.bases.send.review'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LIQUIDACIONES_BASES_DELETE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.liquidaciones.bases.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
};